import PropTypes from 'prop-types';
import React from 'react';
import FootballMatchSummary from './FootballMatchSummary';
import Tabs from 'modules/Common/components/Tabs';
import {MATCH_STATE_FINISHED} from 'modules/Football/consts'
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import JsonLD from 'modules/Common/components/JsonLD';
import {canonicalLink} from 'utils/seoUtils';

export default function FootballLiveMatch(props) {
  require('./FootballLiveMatch.scss');

  const {
    routes,
    match,
    matchId,
    events,
    children
  } = props;

  if (match && match.match_detail) {
    const urlRoot = `/football/live/${matchId}/`;

    const tabs = [
      {href: `${urlRoot}preview`,    text: "Preview"},
      {href: `${urlRoot}commentary`, text: "Commentary"},
      {href: `${urlRoot}stats`,      text: "Stats"},
      {href: `${urlRoot}teams/home`, text: "Teams", alternatives: [{href: `${urlRoot}teams/away`}]},
      {href: `${urlRoot}form`,       text: "Form"}
    ];

    if (match.match_detail.competition.show_tables === true) {
      tabs.push(
        {href: `${urlRoot}table`, text: "Table"}
      );
    }

    if (MATCH_STATE_FINISHED.includes(match.match_detail.state)) {
      tabs.push(
        {href: `${urlRoot}report`,   text: "Report"},
        {href: `${urlRoot}reaction`, text: "Reaction"}
      );
    }

    const {
      match_detail: {
        team_score_a: {
          team: {
            name: homeName
          }
        },
        team_score_b: {
          team: {
            name: awayName
          }
        },
        match_date: matchDate,
        competition: {
          name: competitionName = ""
        },
        venue: venueName
      }
    } = match;

    const matchLabel = `${homeName} v ${awayName}`;

    // Only need the first few route components, to give a constant URL accross all tabs
    const reducedRoutes = routes;
    reducedRoutes.length = 4;

    const {
      link:[
        {
          href: jsonLdUrl = ''
        } = {}
      ] = []
    } = canonicalLink(reducedRoutes, {matchId});

    const jsonLdData = {
      "@type": "SportsEvent",
      "url": jsonLdUrl,
      "homeTeam": {
        "@type": "SportsTeam",
        "name": homeName
      },
      "awayTeam": {
        "@type": "SportsTeam",
        "name": awayName
      },
      "startDate": matchDate,
      "location": {
        "@type": "Place",
        "name": venueName,
        "address": {
          "@type": "PostalAddress",
          "addressLocality": ""
        }
      },
      "superEvent": {
        "@type": "SportsEvent",
        "name": competitionName
      }
    };

    return (
      <div className="football-live-match">
        <MetaDataWrapper helmetProps={{...canonicalLink(routes, {matchId})}}/>
        <JsonLD data={jsonLdData}/>
        <section className="footballLiveMatchHeader">
          <div className="footballLiveMatchSummary">
            <FootballMatchSummary {...{match, matchLabel}}/>
          </div>
          <Tabs tabs={tabs}/>
        </section>
        <section className="content">
          {React.cloneElement(children, { match, matchLabel, events })}
        </section>
      </div>
    );

  } else {

      const errorPixelSrc = `/1x1.gif?type=football-live-match&id=0&cb=${Date.now()}`;

    return (
      <div className="football-live-match">
        <section className="footballLiveMatchHeader">
          <div>There was a problem displaying the match.</div>
          <img src={errorPixelSrc} width="1" height="1" />
        </section>
      </div>
    );

  }
}

FootballLiveMatch.propTypes = {
  routes: PropTypes.array.isRequired,
  match: PropTypes.object,
  events: PropTypes.object,
  matchId : PropTypes.string,
  children: PropTypes.object
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballLiveMatch.js